import { render, staticRenderFns } from "./topUserManagementUpdate.vue?vue&type=template&id=37840b1c&scoped=true"
import script from "./topUserManagementUpdate.vue?vue&type=script&lang=js"
export * from "./topUserManagementUpdate.vue?vue&type=script&lang=js"
import style0 from "./topUserManagementUpdate.vue?vue&type=style&index=0&id=37840b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37840b1c",
  null
  
)

export default component.exports